import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { NftControllerDtoNftGenerateListRequest, PerplayNftApi } from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import { NFT_GENERATE_LIST_REQUEST, NFT_GENERATE_SEAL_LIST_REQUEST } from '../../constants/app/nftConstants';
import NftControllerDtoNftGenerateListResponse from '../../models/src/model/NftControllerDtoNftGenerateListResponse';

const api = new PerplayNftApi(config.API_CLIENT);

function* nftSealListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiPerplayNftNftGenerateSealListPost({  }, () => {});
    const data = api.apiClient.deserialize(result, []);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftGenerateListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new NftControllerDtoNftGenerateListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;

    const result = yield api.apiPerplayNftNftGenerateListPost({ nftControllerDtoNftGenerateListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, NftControllerDtoNftGenerateListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }

}

function* nftRootSaga() {
  yield all([
    takeEvery(NFT_GENERATE_SEAL_LIST_REQUEST, nftSealListRequestSaga),
    takeEvery(NFT_GENERATE_LIST_REQUEST, nftGenerateListRequestSaga),
  ])
}

const nftSagas = [
  fork(nftRootSaga),
];

export default nftSagas;
